import React from 'react';
import { useSelector } from 'react-redux';
import block from 'bem-cn';

import SVG from 'components/SVG';

import infoSVG from 'shared/img/info.svg';
import crossSVG from 'shared/img/cross-info.svg';

import './PercentInfo.scss';

const b = block('percent-info');

const PercentInfo = ({ percent }) => {
  const locale = useSelector(state => state.locale.locale);

  if (!percent && percent !== 0) return null;

  return (
    <div className={b()}>
      <SVG
        className={b('icon')}
        svgProps={{ svg: infoSVG }}
      />
      <div className={b('text')}>
        <SVG
          className={b('cross')}
          svgProps={{ svg: crossSVG }}
        />
        {locale.promoCodePercent.replace('<percent>', percent)}
      </div>
    </div>
  );
};

export default PercentInfo;
